/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFeaturedInWithLogosCf052Fragment} from '@amblique/contentful/app/contentful/fragments/featured-in-with-logos-cf052/base-featured-in-with-logos-cf052.fragment';
import {IconFragment} from '@amblique/contentful/app/contentful/fragments/icon/icon.fragment';

export const FullFeaturedInWithLogosCf052Fragment = gql`
  ${BaseFeaturedInWithLogosCf052Fragment}
  ${IconFragment}

  fragment FullFeaturedInWithLogosCf052Fragment on FeaturedInWithLogosCf052 {
    ...BaseFeaturedInWithLogosCf052Fragment

    iconsCollection {
      items {
        __typename
        ... on Icon {
          ...IconFragment
        }
      }
    }
    iconsCursorCollection {
      items {
        __typename
        ... on Icon {
          ...IconFragment
        }
      }
    }
  }
`;
